// header
var swiper__headerHome = new Swiper('.swiper__headerHome', {
    speed: 500,
    spaceBetween: 0,
    autoplay: {
        delay: 5000,
    },
    hashNavigation: {
        replaceState: true,
        watchState: true,
    },
});

$('.thumbs__swiperHeaderHome a').on('click', function() {
    $('.thumbs__swiperHeaderHome a').removeClass('is-active');
    $(this).addClass('is-active');
});

function slideActiveOnHash() {
    var dataHash = window.location.hash;
    $('.thumbs__swiperHeaderHome a').removeClass('is-active');
    $('.thumbs__swiperHeaderHome a[href="'+dataHash+'"]').addClass('is-active');
    var ifDataHash = dataHash.split('-');
    if (ifDataHash[0] != '#slideHome') {
        $('.thumbs__swiperHeaderHome a').removeClass('is-active');
        $('.thumbs__swiperHeaderHome a[href="#slideHome-01"]').addClass('is-active');
    }
}

swiper__headerHome.on('slideChangeTransitionEnd', function () {
    slideActiveOnHash();
});

$(window).on('load', function() {
    slideActiveOnHash();

    if ($('#recAmbiental').length) {
        $('.js-beforeAfter').twentytwenty({
            before_label: '2008',
            after_label: '2015',
            no_overlay: true,
            move_slider_on_hover: true,
            move_with_handle_only: true,
            click_to_move: true
        });
    }
});